module.exports = __webpack_public_path__ + "img/core-business-mobile.8a903510.jpg";